import { useQuery } from '@tanstack/react-query';

import { fetchMe } from './adminApi';

export const ME_QUERY_KEY = ['admin-auth', 'me'] as const;

/**
 * Wraps GET /api/admin-auth/me. `data === null` (query settled, not loading)
 * is the "no session" outcome the shell/RequireSession redirect on — it is
 * NOT an error state, since an admin who has never logged in hits this on
 * every cold load. Retries are disabled for the same reason: a 401 will not
 * turn into a 200 by asking again.
 */
export function useMe() {
  return useQuery({
    queryKey: ME_QUERY_KEY,
    queryFn: fetchMe,
    retry: false,
    staleTime: 30_000,
  });
}
